module.exports = __webpack_public_path__ + "img/emoFoods.46b23e5d.svg";